export default "__VITE_ASSET__BYIGPSRc__"